import { computed, reactive } from 'vue'
import { getHeats, getResult, getSchedule } from '@api'
import { watchersGetter } from '@store/watchers.js'

const types = [
  {
    value: 'user',
    label: 'Спортмену',
    type: 'input'
  },
  {
    value: 'club',
    label: 'Клубу',
    type: 'input'
  },
  {
    value: 'number',
    label: 'Номеру',
    type: 'input'
  },
  {
    value: 'arrayNumber',
    label: 'Списку номеров',
    type: 'textarea'
  }
]
const store = reactive({
  value: '',
  type: types[0],
  list: [],
  date: '',
  hasBeenScroll: false,
  showOldValue: false,
  sortByDanceIndex: -1,
  ignoreDays: false
})

const getCurrentTypeValue = () => store.type?.value || store.type || types[0].value
const SEARCH_RETRY_LIMIT = 3
const SEARCH_RETRY_DELAY_MS = 250
const SEARCH_ACTIVE_GROUP_CONCURRENCY = 8
const SEARCH_ALL_GROUP_CONCURRENCY = 4

const getGroupKey = group =>
  String(group?.id || group?.currentRound?.groupId || group?.currentRound?.roundId || '').trim()

const getActiveGroupIds = () => {
  const activeDayItems = Array.isArray(watchersGetter.activeDayData()?.items)
    ? watchersGetter.activeDayData().items
    : []

  const ids = activeDayItems
    .map(item => String(item?.dance?.groupId || item?.dance?.roundId || item?.id || '').trim())
    .filter(Boolean)

  return new Set(ids)
}

const runWithLimit = async (items, limit, worker) => {
  const queue = Array.isArray(items) ? [...items] : []
  if (!queue.length) return

  const workerCount = Math.max(1, Math.min(limit, queue.length))
  const workers = Array.from({ length: workerCount }, async () => {
    while (queue.length) {
      const next = queue.shift()
      await worker(next)
    }
  })

  await Promise.all(workers)
}

export const searchGetter = {
  ignoreDays() {
    return store.ignoreDays
  },
  sortByDanceIndex() {
    return store.sortByDanceIndex
  },
  showOldValue() {
    return store.showOldValue
  },
  value: () => {
    return store.value
  },
  type() {
    return store.type
  },
  types() {
    return [...types]
  },
  list() {
    return store.list
  },
  date(){
    return store.date
  },
  link(){
    return store.link
  }
}
const sendSearchByGroup = (group, competitonId, callBackFn, steps = 0, local=false) => {
  //todo round
  const params = new URLSearchParams(location.search)
  if (
    store.value.toLocaleLowerCase() != params.get('search') ||
    getCurrentTypeValue() != params.get('search-type')
  ) {
    if(store.value.toLocaleLowerCase().length){
      params.set('search', store.value.toLocaleLowerCase())
      params.set('search-type', getCurrentTypeValue())
      params.set('show-old-value', store.showOldValue)
    }else if(params.get('search')){
      location.search = ''
    }
    history.pushState(null, '', '?' + params.toString())
  }
  getResult(group, competitonId,local)
    .then(res => {
      const timeGroups = watchersGetter.timeGroups()
      let date = timeGroups[group.id]
      if (!date) {
        const fallbackDay = watchersGetter.schedule()?.days?.[0]?.date
        if (fallbackDay) {
          date = new Date(fallbackDay)
        }
      }
      if(store.date && (!date || (date.getDate())+'.'+(date.getMonth()+1)+'.'+(date.getFullYear()) != store.date)){
        callBackFn()
        return
      }

      res.competitors.forEach(item => {
        let searchString = ''
        switch (getCurrentTypeValue()) {
          case 'user':
            let athlete1
            let athlete2
            if (!item?.athletes?.[0]) {
              return
            }
            if ('athlete' in item.athletes[0]) {
              athlete1 = item.athletes[0].athlete
              athlete2 = item.athletes[1].athlete
            } else {
              athlete1 = item.athletes[0]
              athlete2 = item.athletes[1]
            }
            searchString = [
              athlete1.fullName.lastName,
              athlete1.fullName.firstName,
              athlete1.fullName.patronymic
            ]
            if (athlete2) {
              searchString.push(athlete2.fullName.lastName)
              searchString.push(athlete2.fullName.firstName)
              searchString.push(athlete2.fullName.patronymic)
            }
            searchString = searchString.join(' ').toLocaleLowerCase()
            break
          case 'club':
            searchString = item.club
            break
          case 'number':
            searchString = item.number
            // store.list.push(item)
            break


        }
        searchString = (searchString + '').trim()
        let hasFound = false
        if(getCurrentTypeValue() == 'arrayNumber'){
          let searchArr = store.value.split(/[ ,;]/).filter(i=>i).map(i=>i.trim()-0)
          hasFound = searchArr.indexOf(item.number) >= 0

        }else{
          hasFound = searchString
            .toLocaleLowerCase()
            .search(store.value.toLocaleLowerCase()) >= 0
        }

        if (hasFound) {
          item.group = group
          item.group.date = timeGroups[group.id]
          store.list.push(item)

          if (!store.hasBeenScroll) {
            store.hasBeenScroll = true
            window.scrollTo({
              top:
                document.querySelector('.results').getClientRects()[0].top +
                window.scrollY,
              behavior: 'smooth'
            })
          }
        }
      })
      callBackFn()
    })
    .catch(e => {
      if (steps < SEARCH_RETRY_LIMIT) {
        const delayMs = SEARCH_RETRY_DELAY_MS * (steps + 1)
        setTimeout(() => {
          sendSearchByGroup(group, competitonId, callBackFn, steps + 1, local)
        }, delayMs)
        return
      }
      console.error('search group failed', group?.id, e)
      callBackFn()
    })
}
export const searchAction = {
  setSortByDanceIndex(index) {
    if (store.sortByDanceIndex === index) {
      store.sortByDanceIndex = -1
    } else {
      store.sortByDanceIndex = index
    }
  },
  async updateList(local = false) {
    store.list = []
    //
    const schedule = watchersGetter.schedule()
    store.hasBeenScroll = false
    const allGroups = Array.isArray(schedule?.groups) ? schedule.groups : []
    const activeGroupIds = getActiveGroupIds()
    const filteredGroups = allGroups.filter(group => {
      if (store.showOldValue) return true
      if (activeGroupIds.size > 0) {
        const key = getGroupKey(group)
        return key && activeGroupIds.has(key)
      }
      return Boolean(group?.currentRound)
    })

    const uniqueGroupsMap = new Map()
    filteredGroups.forEach(group => {
      const key = getGroupKey(group) || String(group?.name || '')
      if (!key || uniqueGroupsMap.has(key)) return
      uniqueGroupsMap.set(key, group)
    })
    const groups = [...uniqueGroupsMap.values()]

    const limit = store.showOldValue
      ? SEARCH_ALL_GROUP_CONCURRENCY
      : SEARCH_ACTIVE_GROUP_CONCURRENCY

    await runWithLimit(groups, limit, group => {
      return new Promise(res => {
        sendSearchByGroup(group, watchersGetter.competitonId(), res, 0, local)
      })
    })
  }
}

export const searchSetter = {
  ignoreDays(value) {
    store.ignoreDays = value
  },
  type(type) {
    store.type = type
  },
  value(value) {
    store.value = value + ''
  },
  date(value) {
    store.date = value + ''
  },
  link(value) {
    store.link = value + ''
  },
  showOldValue(value) {
    store.showOldValue = value
  }
}
